var _path, _path2, _path3, _path4, _path5, _circle, _path6, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 24.75V43.5209C19 45.3242 19.6672 48.0019 22.9574 48.0019C26.2476 48.0019 27.0866 45.3242 27.0866 43.5209V31.573C27.0866 30.478 27.6425 28.2879 29.8663 28.2879C32.0901 28.2879 33.1785 28.2879 33.7681 28.2879",
    stroke: "#FF8165",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7236 16.2188C12.3627 20.4892 15.3022 23.9635 19.7889 23.9635C23.1647 23.9635 25.9883 20.7876 26.9461 16.2188",
    stroke: "#1552E8",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6133 24.75V43.5209C19.6133 45.3242 20.2805 48.0019 23.5707 48.0019C26.8609 48.0019 27.6998 45.3242 27.6998 43.5209V31.573C27.6998 30.478 28.2558 28.2879 30.4796 28.2879C32.7034 28.2879 33.7918 28.2879 34.3814 28.2879",
    stroke: "#081E54",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2744 5.5625V15.9234C11.3586 18.7874 13.0939 24.5154 19.361 24.5154C25.6281 24.5154 27.3633 18.7874 27.4475 15.9234V5.5625",
    stroke: "#081E54",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2744 14.6484C12.201 16.5016 15.1155 20.208 19.361 20.208C23.6064 20.208 26.521 16.5016 27.4475 14.6484",
    stroke: "#081E54",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.2743,
    cy: 3.27435,
    r: 1.80768,
    fill: "#E7EDFF",
    stroke: "#081E54",
    strokeWidth: 0.933333
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2549 3.27435C29.2549 4.2727 28.4456 5.08203 27.4472 5.08203C26.4488 5.08203 25.6395 4.2727 25.6395 3.27435C25.6395 2.27599 26.4488 1.46667 27.4472 1.46667C28.4456 1.46667 29.2549 2.27599 29.2549 3.27435Z",
    fill: "#E7EDFF",
    stroke: "#081E54",
    strokeWidth: 0.933333
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1411,
    cy: 28.2681,
    r: 3.29359,
    stroke: "#081E54",
    strokeWidth: 0.933333
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1628,
    cy: 28.238,
    r: 2.13648,
    fill: "#A020FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon-5.88c3b291dd1a9d689edbf355d39514b7.svg";
export { ForwardRef as ReactComponent };